import { Component, OnInit, OnDestroy } from '@angular/core';
import { LabelInterface, LabelClass } from '../label';
import { AssetService, LabelService } from '../services';
import { AssetModel } from '../asset/asset.model';
import { ClassModel, ClassService } from '../class';
import { PlaceModel, PlaceService } from '../place';
import { switchMap } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { plainToClass } from 'class-transformer';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-asset-new-page',
  templateUrl: './asset-new-page.component.html',
  styleUrls: ['./asset-new-page.component.scss'],
})
export class AssetNewPageComponent implements OnInit, OnDestroy {


  label: LabelInterface = new LabelClass();

  loading = false;

  asset: AssetModel = new AssetModel();

  subs = new Subscription();

  date = new UntypedFormControl(this.asset.aquisitionDate);

  classes: ClassModel[] = [];
  places: PlaceModel[] = [];

  constructor(private assetService: AssetService, private labelService: LabelService,
              private classService: ClassService, private placeService: PlaceService,
              private _snackBar: MatSnackBar) {

    // this.asset._id = 0;
    this.subs.add(this.date.valueChanges.subscribe(
      (data) => { this.label.date = data; },
      (error) => {},
      () => {}
    ));

    this.subs.add(this.classService.list().subscribe(
      (data) => { this.classes = data; },
      (error) => {},
      () => {}
    ));

    this.subs.add(this.placeService.list().subscribe(
      (data) => {
        this.places = data;
        this.renderLabel(this.asset);
      },
      (error) => {},
      () => {}
    ));

  }

  ngOnInit(): void {
    if (history.state._id) {
      this.asset = plainToClass(AssetModel, history.state);
      delete this.asset._id;
      this.renderLabel(this.asset);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  renderLabel(data: AssetModel): void {
    // this.asset = data;
    const place = this.places.find((element) => {
      return element._id === this.asset._placeId;
    });
    if (!place) { return; }
    this.label = this.labelService.getLabel(this.asset, place);
  }

  addPrintAsset(): void {
    this.loading = true;

    this.assetService.create(this.asset).pipe(
      switchMap((data) => {
        this.label.id = data._id;
        return this.labelService.printLabel(this.label);
      })
    ).subscribe(
      (data) => {},
      (error) => {
        let message: string = error.message;
        if (error.error && error.error.message) {
          message = error.error.message;
        }
        this._snackBar.open(message, '', {
          duration: 5000,
        });
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.asset = new AssetModel();
        this.label = {
            id: 0,
            place: '',
            info: '',
            date: new Date(),
            type: '25x70_25x17'
        };
      }
    );
  }

}
